import { Injectable } from '@angular/core';
import { v4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ClientIdService {
  private _clientId: string;

  constructor() {
    const storedClientId = localStorage.getItem('clientId');
    if (storedClientId) {
      this._clientId = storedClientId;
    } else {
      this._clientId = this.generateClientId();
    }
  }

  private generateClientId(): string {
    const clientId = v4();
    localStorage.setItem('clientId', clientId);
    return clientId;
  }

  get clientId(): string {
    return this._clientId;
  }
}
